export const getTrainingMetadata = (): string[] => {
  return []
}
